import { mapStore } from "../store";

type GlobalSearchLocationPayload = {
  geometry: { location: google.maps.LatLng };
  place: google.maps.places.PlaceResult | null;
} | null;

export const updateGlobalSearch = (globalSearch: string) => {
  mapStore.globalSearch = globalSearch;
};

export const clearGlobalSearch = () => {
  mapStore.globalSearch = "";
};

export const clearGlobalSearchMapPin = () => {
  mapStore.settings.globalSearchMapPin = null;
};

export const setGlobalSearchMapPinFromCallback = (search: GlobalSearchLocationPayload) => {
  if (!search?.geometry?.location) {
    clearGlobalSearchMapPin();
    return;
  }

  const { location } = search.geometry;
  const place = search.place;
  mapStore.settings.globalSearchMapPin = {
    lat: location.lat(),
    lng: location.lng(),
    placeName: place?.name ?? place?.formatted_address ?? "",
  };
};
